import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

import Paragraph from 'components/Paragraph';
import Button from 'components/Button';
import { Date } from 'apps/components/date';
import Avatar from 'components/Avatar';
import { FileViewer } from 'libs/rendering';

import { Center } from 'legacyComponents/styled/lib';
import {
  ConflictColumn,
  ActionWrapper,
  ViewerWrapper,
  NoFile,
  IconStyled,
  ContribFileHeader,
  Status,
} from 'apps/project/tabs/conflicts/styles';

export const LocalConflict = withNamespaces()(
  observer(({ conflicts, activeConflict, manager }) => {
    if (!conflicts || conflicts.length === 0) {
      return <ConflictColumn last />;
    }

    const conflict = conflicts.apps[activeConflict];
    const { local, localStatus } = conflict;
    const { creator } = local;
    const { username } = creator;
    const removed = localStatus === 'REMOVED';

    const header = (
      <ContribFileHeader>
        <div>
          <Avatar
            src={creator.profile.avatar?.url}
            name={creator.profile.fullName}
            size='xmedium'
          />
          <Paragraph>{local.filename}</Paragraph>
          <Status red={removed}>
            <Trans>{localStatus}</Trans>
          </Status>
          <Paragraph>
            <Trans>
              <a href='' target='_blank'>
                changed
              </a>{' '}
              by {{ username }}, <Date value={local.lastUpdated} />
            </Trans>
          </Paragraph>
        </div>
      </ContribFileHeader>
    );
    const { SetResolution, resolution } = manager;

    const resolutionValue = removed ? null : local.id;
    const isResolution =
      Object.keys(resolution.toJS()).includes(conflict.path) &&
      resolution.get(conflict.path) === resolutionValue;

    return (
      <ConflictColumn>
        {header}
        <ViewerWrapper>
          {isResolution && <IconStyled name='success' />}
          {removed ? (
            <Center>
              <NoFile>
                <Trans>This file was deleted</Trans>
              </NoFile>
            </Center>
          ) : (
            <FileViewer isPreview file={local} />
          )}
        </ViewerWrapper>
        <ActionWrapper>
          {isResolution ? null : (
            <Center>
              {removed ? (
                <Button
                  text={<Trans>Delete file</Trans>}
                  variant='destructive'
                  size='small'
                  onClick={() =>
                    SetResolution('delete', conflict, null, activeConflict)
                  }
                />
              ) : (
                <Button
                  text={<Trans>Pick file</Trans>}
                  size='small'
                  onClick={() =>
                    SetResolution('pick', conflict, local.id, activeConflict)
                  }
                  outline
                />
              )}
            </Center>
          )}
        </ActionWrapper>
      </ConflictColumn>
    );
  }),
);
